import type { JSX } from 'react';

import { Icon } from '@trend-dev/ui-libs-icons';

import type { ControlType } from 'store/controls';

type NonStoreControls = 'invite';

export interface Control {
    className?: string;
    getIcon: (isEnabled?: boolean) => JSX.Element;
    label: string;
    /** Тип элемента управления в сторе */
    storeType?: ControlType;
    /** Тип элемента управления */
    type: ControlType | NonStoreControls;
}

const label = {
    camera: 'Камера',
    invite: 'Пригласить',
    leave: 'Выйти',
    microphone: 'Микрофон',
    screen: 'Показать экран',
};

export const microphone: Control = {
    getIcon: isEnabled => <Icon name={isEnabled ? 'Mic_20' : 'MicOff_20'} />,
    label: label.microphone,
    storeType: 'mic',
    type: 'mic',
};

export const camera: Control = {
    getIcon: isEnabled => <Icon name={isEnabled ? 'VideoCamera_20' : 'VideoCameraOff_20'} />,
    label: label.camera,
    storeType: 'cam',
    type: 'cam',
};

export const screen: Control = {
    getIcon: () => <Icon name='Monitor_20' />,
    label: label.screen,
    storeType: 'screen',
    type: 'screen',
};

export const invite: Control = {
    getIcon: () => <Icon name='UserPlus_20' />,
    label: label.invite,
    type: 'invite',
};

export const leave: Control = {
    className: 'leave',
    getIcon: () => <Icon name='Logout_20' />,
    label: label.leave,
    storeType: 'leave',
    type: 'leave',
};
